import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AppShell } from './ui/AppShell';
import { AdminOverviewPrintPage } from './views/AdminOverviewPrintPage';
import { AdminSessionPrintPage } from './views/AdminSessionPrintPage';
import { AdminImportsPage } from './views/AdminImportsPage';
import { AdminLoginPage } from './views/AdminLoginPage';
import { AgendaPage } from './views/AgendaPage';
import { LoginPage } from './views/LoginPage';
import { MyPlanPrintPage } from './views/MyPlanPrintPage';
import { MyPlanPage } from './views/MyPlanPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/agenda" replace />,
  },
  {
    path: '/login',
    element: (
      <AppShell compact>
        <LoginPage />
      </AppShell>
    ),
  },
  {
    path: '/agenda',
    element: (
      <AppShell>
        <AgendaPage />
      </AppShell>
    ),
  },
  {
    path: '/my-plan',
    element: (
      <AppShell>
        <MyPlanPage />
      </AppShell>
    ),
  },
  {
    path: '/my-plan/print',
    element: <MyPlanPrintPage />,
  },
  {
    path: '/admin',
    element: <Navigate to="/admin/program" replace />,
  },
  {
    path: '/admin/login',
    element: (
      <AppShell compact adminMode>
        <AdminLoginPage />
      </AppShell>
    ),
  },
  {
    path: '/admin/program',
    element: (
      <AppShell adminMode>
        <AdminImportsPage />
      </AppShell>
    ),
  },
  {
    path: '/admin/workshops/:sessionId/print',
    element: <AdminSessionPrintPage />,
  },
  {
    path: '/admin/overview/print',
    element: <AdminOverviewPrintPage />,
  },
  {
    path: '/admin/imports',
    element: <Navigate to="/admin/program" replace />,
  },
]);
